// @ts-nocheck
/* global css */
import React from 'react';
import cx from 'classnames';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';
import Collapse from '../../shared/collapse';
import FieldLabel from './field-label';
import RequiredIndicator from './required-indicator';
import DescriptionButton from './description-button';

interface Props {
  children: Element | React.ReactNode,
  visible?: boolean,
  required?: boolean,
  disabled?: boolean,
  label?: string,
  description?: string,
  bottomBorder?: boolean,
  dataTestID?: string,
  labelAlignTop?: boolean,
}

/**
 * Labeled field wrapper for the legacy record editor (element-list-view).
 * Handles visibility, required indicator, label, and description display.
 */
const LabeledField: React.FC<Props> = ({
  children,
  visible = true,
  required = false,
  disabled = false,
  label = '',
  description = '',
  bottomBorder = true,
  dataTestID,
  labelAlignTop = false,
}: Props) => {
  const cssStyles = css(styles.container,
    bottomBorder && styles.border,
    styles.editing,
    required && styles.required,
    disabled && styles.disabled);
  const hasDescription = description?.length > 0;
  const elementStyle = hasDescription ? styles.withDescription : styles.withoutDescription;

  return (
    <Collapse open={visible} dataTestID={dataTestID}>
      <div className={cx('element', cssStyles)}>
        <div className={css(styles.content)}>
          <FieldLabel key="label" label={label} className={css(styles.label, labelAlignTop && styles.labelAlignTop)} />
          <RequiredIndicator key="required" required={required} />
          <div
            key="editable"
            className={css(styles.editableContent, elementStyle)}
          >
            {children}
          </div>
          { !!description && (
            <DescriptionButton
              key="info"
              description={description}
              label={label}
            />
          )}
        </div>
      </div>
    </Collapse>
  );
};

const styles = cssInJS({
  container: {
    width: '100%',
    position: 'relative',
    padding: 0,
    clear: 'both',
    fontSize: 13,
    backgroundColor: '#fff',
  },

  border: {
    borderBottom: THEME.fieldBorderLight,
  },

  editableContent: {
    display: 'inline-block',
    paddingRight: 12,
  },

  withoutDescription: {
    width: '58%',
  },

  withDescription: {
    width: '55%',
  },

  content: {
    display: 'flex',
    flexDirection: 'row',
  },

  labelAlignTop: {
    alignItems: 'flex-start',
    paddingTop: '16px',
    paddingLeft: '16px',
  },
});

export default LabeledField;
